import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Web3ReactProvider } from '@web3-react/core';
import { Provider } from 'react-redux';

import './index.css';
import App from './App';
import store from './store/index.js';
import './mock/index.js';
// import {getWeb3Library} from './utils';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
      <Suspense fallback='loading'>
        <App />
      </Suspense>
    </Provider>
);
